<template>
  <div>
    <textarea :id="ueId" type="text/plain" />
  </div>
</template>

<script>
export default {
  name: 'UEditor',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    wordCount: {
      type: Boolean,
      default: false
    },
    maximumWords: {
      type: Number,
      default: 10000
    },
    disableUpload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ueId: `J_ueditorBox_${new Date().getTime()}`,
      ue: null,
      info: ''
    }
  },
  watch: {
    value: {
      handler(value) {
        // console.log(value, 'value')
        if (value !== this.info) {
          if (this.ue) {
            this.ue &&
              this.ue.ready(() => {
                // console.log(value)
                this.info = value
                this.ue.setContent(value)
              })
          } else {
            this.$nextTick(() => {
              this.seteditor()
            })
          }
        }
      },
      deep: true,
      immediate: true
    }
    // value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
  },
  beforeDestroy() {
    try {
      if (this.ue) {
        // 移除所有事件监听器
        this.ue.removeListener('contentChange')
        // 确保编辑器实例存在且有 destroy 方法
        if (typeof this.ue.destroy === 'function') {
          this.ue.destroy()
        }
      }
      // 如果还需要使用全局 UE，确保它存在
      // eslint-disable-next-line no-undef
      if (window.UE && UE.getEditor(this.ueId)) {
        // eslint-disable-next-line no-undef
        UE.getEditor(this.ueId).destroy()
      }
    } catch (error) {
      console.warn('UEditor cleanup error:', error)
    }
  },
  mounted() {
    try {
      // 确保 UEditor 已经加载
      if (window.UE) {
        this.seteditor()
      } else {
        console.warn('UEditor not loaded yet, waiting...')
        // 等待 UEditor 加载完成
        const checkUE = setInterval(() => {
          if (window.UE) {
            clearInterval(checkUE)
            this.seteditor()
          }
        }, 100)
        // 设置超时，避免无限等待
        setTimeout(() => {
          clearInterval(checkUE)
          console.error('UEditor load timeout')
        }, 5000)
      }
    } catch (error) {
      console.error('UEditor init error:', error)
    }
  },
  methods: {
    seteditor() {
      try {
        // 如果已经有实例了，先销毁
        if (this.ue) {
          this.ue.destroy()
        }
        // eslint-disable-next-line no-undef
        this.ue = UE.getEditor(this.ueId, {
          maximumWords: this.maximumWords,
          wordCount: this.wordCount
        })

        const that = this
        // 确保实例创建成功
        if (!this.ue) {
          throw new Error('Failed to create UEditor instance')
        }

        if (!this.disableUpload) {
          that.ue.commands['addimgv2'] = {
            execCommand: function () {
              const that2 = this
              that.$SelectMaterialMultiple({
                visible: true,
                type: 'imageView',
                types: [0],
                success: res => {
                  if (res.imageList.length > 0) {
                    res.imageList.forEach(v => {
                      const materialUrl =
                        v.materialUrl + '?x-oss-process=image/format,webp'
                      that2.execCommand(
                        'insertHtml',
                        `<img src='${materialUrl}' style="vertical-align: middle;width: 100%"/>`
                      )
                    })
                  }
                }
              })
              return true
            },
            queryCommandState: function () {}
          }

          that.ue.commands['addvideov2'] = {
            execCommand: function () {
              const that2 = this
              that.$OSSUpload({
                visible: true,
                success: res => {
                  console.log(res, 'res')
                  const arr = []
                  res.map(v => {
                    arr.push({
                      url: v.url,
                      width: '650',
                      controls: 'true'
                    })
                  })
                  that2.execCommand('insertvideo', arr)
                }
              })
              return true
            },
            queryCommandState: function () {}
          }
        } else {
          // 禁用上传：点击按钮时给出提示
          that.ue.commands['addimgv2'] = {
            execCommand: function () {
              that.$message && that.$message.warning('当前场景已禁用图片上传')
              return true
            },
            queryCommandState: function () {}
          }
          that.ue.commands['addvideov2'] = {
            execCommand: function () {
              that.$message && that.$message.warning('当前场景已禁用视频上传')
              return true
            },
            queryCommandState: function () {}
          }
        }

        // 使用一个变量跟踪编辑器是否已经准备就绪
        let editorReady = false

        that.ue.addListener('contentChange', () => {
          if (!editorReady) return
          const content = that.ue.getContent()
          this.info = content.replace(
            /\<img/gi,
            '<img style="width: 100%;height:auto;"'
          )
          that.$emit('change', this.info)
        })

        this.ue.ready(() => {
          editorReady = true
          if (this.value) {
            this.ue.setContent(this.value)
          }
        })
      } catch (error) {
        console.error('UEditor setup error:', error)
      }
    },
    getContent() {
      const content = this.ue.getContent()
      this.info = content.replace(
        /\<img/gi,
        '<img style="width: 100%;height:auto;"'
      )
      return this.info
    },
    getText() {
      return this.ue.getContentTxt()
    },
    // 添加 dataURL 转 File 的工具方法
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    }
  }
}
</script>

<style></style>
